<template>
  <page>
    <template slot="title">Контакты</template>
    <template slot="section">
      <div class="contacts">
        <p><b>Адрес в Москве:</b><br/>г. Москва, ул. Садовая-Кудринская д. 11, стр. 1</p>
        <line-break size="s"/>
        <p><b>Телефон:</b><br/><a href="tel:84957739215">8 (495) 773-92-15</a></p>
        <line-break size="s"/>
        <p><b>Электронная почта:</b><br/><a href="mailto:info@arkenergosbyt.ru">info@arkenergosbyt.ru</a></p>
        <line-break size="s"/>
        <div id="arkMap" class="map">
          <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A4880b45ccb329ad69e4062b81a47419741de1ffa0ce4df019364ed6cf5a66c53&amp;source=constructor" width="100%" height="366" frameborder="0"></iframe>
        </div>
      </div>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-10.jpg';

import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';
import LineBreak from '@/components/LineBreak';

export default {
  components: {
    Page,
    AsideImage,
    LineBreak,
  },
  data: () => {
    return {
      imageBg: imageBg,
    }
  }
}
</script>

<style lang="scss">
.contacts p {font-weight: 300;}
.contacts b {font-weight: 400;}
.map {
  width: 100%;
  height: 366px;
}
</style>



// WEBPACK FOOTER //
// Contacts.vue?1db2e68e